// React
import React from 'react';

// Prop types
import PropTypes from 'prop-types';

// Component
import ChangePersonDialog from './ChangePersonDialog';
import DeviceSettings from '../Common/DeviceSettings';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

const styles = () =>
	({
		root : {
			height          : 'calc(100% - 100px)',
			aspectRatio     : 1.777,
			maxWidth        : '98vw',
			minWidth        : 800,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '2%',
			overflow        : 'auto'
		},
		wrapper : {
			width                  : '30%',
			margin                 : '0 auto',
			height                 : '100%',
			overflow               : 'auto',
			'&::-webkit-scrollbar' : {
				background   : '#ccc',
				width        : '7px',
				height       : '7px',
				borderRadius : '100px'
			},
			'&::-webkit-scrollbar-thumb' : {
				background   : '#888',
				borderRadius : '100px',
				'&:hover'    : {
					background : '#555'
				}
			}
		}
	});

class Setting extends React.PureComponent
{
	render()
	{
		const {
			classes,
			settings
		} = this.props;

		return (
			<>
				<div className={classes.root}>
					<div className={classes.wrapper}>
						<DeviceSettings isHost />
					</div>
				</div>

				{settings.changePersonDialogOpen &&
					<ChangePersonDialog/>
				}
			</>
		);
	}

	componentDidMount()
	{
	}

	componentDidUpdate()
	{
	}
}

Setting.propTypes =
{
	classes  : PropTypes.object.isRequired,
	settings : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		settings : state.settings
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.settings.changePersonDialogOpen === next.settings.changePersonDialogOpen
			);
		}
	}
)(withStyles(styles)(Setting)));
